import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';

import {
  FormControl,
  ReactiveFormsModule,
  FormsModule,
} from '@angular/forms';
import { UpdateMemberService } from '../services/raintree/Transmission/update-member.service';
import { MemberSearchResponseData, MemberSearchResponseObj } from '../services/raintree/interfaces/member-search';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { CommonUtilService } from '../services/common-util/common-util.service';
import { keyboardInputValidators } from '../services/common/form-control';
import { Validation } from '../services/common/app.constant';
import { RequestMapper } from '../request-mapper';
@Component({
  selector: 'app-update-member',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule, FormsModule],
  templateUrl: './update-member.component.html',
  styleUrl: './update-member.component.scss',
})
export class UpdateMemberComponent {
  memberDetails!: MemberSearchResponseObj | null;
  memberId = new FormControl();
  recordStatus!: number;
  updatedBy!: string|number;
  userID!: string;
  status!: string;
  isMobile: boolean = false;

  constructor(
    private _updateMemberService: UpdateMemberService,
    private router: Router,
    private _toastr: ToastrService,
    private isMobileService: CommonUtilService
  ) {}

  ngOnInit() {
    this.userID = localStorage.getItem('userId')!;
    this.isMobile = this.isMobileService.isMobileDevice();
  }

  restrictSerialNoInput(event: KeyboardEvent): void {
    keyboardInputValidators(event, Validation.regex.number);
  }

  onSearch() {
    if (this.memberId.value == null) {
      this.memberDetails = null;
    }
  }

  onSubmit() {
    if (this.memberId.value) {
      let updateObj = {
        address: '',
        memberName: '',
        memberKey: this.memberId.value,
        pageNo: 1,
      };

      this._updateMemberService.fetchMemberDetails(updateObj).subscribe({
        next: (response: MemberSearchResponseData) => {
          this.memberDetails = response.data[0];
          this.recordStatus = response.data[0].recordStatus;
          this.updatedBy = response.data[0].updatedBy;
          switch (this.recordStatus) {
            case 2:
            case 5:
            case 7:
            case 9:
            case 10:
              this.status = 'Updated';
              break;
            case 6:
              this.status = 'DA Rejected';
              break;
            case 8:
              this.status = 'SU Rejected';
              break;
            default:
              this.status = 'Not Updated';
              break;
          }
        },
        error: (error) => {
          this.memberDetails = null;
          this._toastr.error(error);
        },
      });
    }else{
      this._toastr.error('Please enter Valid member Id');
    }
  }

  clear() {
    this.memberId.reset();
    this.memberDetails = null;
  }

  update() {
    let dataToPass = {
      recordStatus: this.recordStatus,
      updatedBy: this.updatedBy,
    };
    const validStatuses = [2, 5, 6, 7, 8, 9, 10];
    const rejectStatuses=[6,8]
    const userId=parseInt(this.userID)
    if (
      validStatuses.includes(this.recordStatus)  && this.updatedBy != this.userID
    ) {
      
      this._toastr.error(
        'This member had already been updated by different field worker.'
      );}
      else if( !rejectStatuses.includes(this.recordStatus) && this.updatedBy === userId){
     this.router.navigate([RequestMapper.WORK_HISTORY])
    } else {
      this.router.navigate(['/update', this.memberDetails?.memberKey], {
        queryParams: dataToPass,
      });
    }
  }
}

